import {
  DropDown, Box, Text, TextButton
} from '@binance/uikit'

export default function Tooltip ({
  tip, label, noBorder, style
}) {
  return (
    <DropDown
      tigger="hover"
      overlay={
        <Box
          bg="button"
          style={{
            width: '280px',
            whiteSpace: 'normal',
            boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.5)',
            ...style
          }}
          p={5}
        >
          <Text.Base lineHeight="1.5">{tip}</Text.Base>
        </Box>
      }
    >
      <TextButton
        fontWeight={400}
        fontSize={1}
        borderBottom={noBorder ? '' : '1px dotted #848E9C'}
        color="caption"
        ml={0}
        mb={0}
        hover="rgba(132,142,156,0.7)"
      >
        {label}
      </TextButton>
    </DropDown>
  )
}
